class Top {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.init();
    }
  }

  init() {
    this.event();
  }

  event() {
    this.initPhotoStripSwiper();
    this.initPeopleSwiper();
    this.initEnvironmentImg();
  }

  /**
   * FUTURE 直下フォトストリップ（s-slider-img01〜08）
   */
  initPhotoStripSwiper() {
    const root = document.querySelector(".p-top .js-topPhotoStripSwiper");
    if (!root || typeof Swiper === "undefined") return;

    new Swiper(root, {
      loop: true,
      slidesPerView: "auto",
      spaceBetween: 16,
      allowTouchMove: false,
      speed: 6000,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },
    });
  }

  /**
   * PEOPLE: SP（767px以下）は2件以上で Swiper＋ナビ。PCは4件以上。
   * 1件・または PC で2〜3件は静的表示・ナビ非表示。
   */
  initPeopleSwiper() {
    const root = document.querySelector(".p-top .js-topPeopleSwiper");
    const wrap = document.querySelector(".p-top .s-people__slider-wrap");
    if (!root || !wrap || typeof Swiper === "undefined") return;

    const peopleCount = parseInt(wrap.getAttribute("data-people-count") || "0", 10);
    if (peopleCount === 0) return;

    const nextEl = document.querySelector(".p-top .s-people__next");
    const prevEl = document.querySelector(".p-top .s-people__prev");
    const paginationEl = document.querySelector(".p-top .s-people__pagination");
    if (!nextEl || !prevEl || !paginationEl) return;

    const mqSp = window.matchMedia("(max-width: 767px)");
    let swiperInstance = null;

    const shouldUseSwiper = () => {
      if (mqSp.matches) {
        return peopleCount >= 2;
      }
      return peopleCount >= 4;
    };

    const apply = () => {
      if (!shouldUseSwiper()) {
        if (swiperInstance) {
          swiperInstance.destroy(true, true);
          swiperInstance = null;
        }
        wrap.classList.add("is-people-static");
        return;
      }

      wrap.classList.remove("is-people-static");
      if (swiperInstance) return;

      swiperInstance = new Swiper(root, {
        slidesPerView: "auto",
        spaceBetween: 16,
        watchOverflow: false,
        navigation: {
          nextEl,
          prevEl,
        },
        pagination: {
          el: paginationEl,
          type: "progressbar",
        },
        breakpoints: {
          768: {
            slidesPerView: "auto",
            spaceBetween: 18,
          },
          1024: {
            slidesPerView: "auto",
            spaceBetween: 20,
          },
        },
      });
    };

    apply();
    mqSp.addEventListener("change", apply);
  }

  /**
   * ENVIRONMENT（s-environment）リストホバー／フォーカスで右カラム画像をフェード切り替え
   */
  initEnvironmentImg() {
    const section = document.querySelector(".p-top .s-environment");
    if (!section) return;

    const inner = section.querySelector(".s-environment__inner");
    const layers = section.querySelectorAll(".js-environmentImgLayer");
    const items = section.querySelectorAll(".s-environment__item[data-environment-src]");
    if (!inner || layers.length !== 2 || items.length === 0) return;

    const defaultSrc =
      layers[0].getAttribute("data-default-src") ||
      layers[0].getAttribute("src") ||
      "";

    let visibleLayer = 0;
    let swapToken = 0;

    const showSrc = (src) => {
      if (!src) return;

      const outgoing = layers[visibleLayer];
      if (outgoing.src === src) return;

      const incoming = layers[1 - visibleLayer];
      const myToken = ++swapToken;

      const reveal = () => {
        if (myToken !== swapToken) return;
        incoming.classList.add("is-visible");
        outgoing.classList.remove("is-visible");
        visibleLayer = 1 - visibleLayer;
      };

      incoming.src = src;

      if (incoming.complete) {
        reveal();
        return;
      }

      incoming.addEventListener(
        "load",
        () => {
          if (myToken !== swapToken) return;
          reveal();
        },
        { once: true },
      );
    };

    items.forEach((item) => {
      const src = item.getAttribute("data-environment-src");
      const link = item.querySelector(".s-environment__item-link");
      if (!link || !src) return;

      link.addEventListener("mouseenter", () => showSrc(src));
      link.addEventListener("focusin", () => showSrc(src));
    });

    inner.addEventListener("mouseleave", () => showSrc(defaultSrc));

    inner.addEventListener("focusout", (e) => {
      const next = e.relatedTarget;
      if (!next || !inner.contains(next)) {
        showSrc(defaultSrc);
        return;
      }
      const onEnvLink = [...items].some((el) => el.contains(next));
      if (!onEnvLink) showSrc(defaultSrc);
    });
  }
}
